import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { ToastType } from '../../../enums/toast-type.enum';
import { Animations } from '../../animations/animations';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    imports: [CommonModule],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [Animations.slideInOutRight],
})
export class ToastComponent {
    public toasts = computed(() => this.toastService.toasts());
    public readonly ToastType = ToastType;

    constructor(public readonly toastService: ToastService) {}
}
